
import { Helmet } from "react-helmet";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import AccessibilityEnhancer from "@/components/common/AccessibilityEnhancer";
import BackButton from "@/components/common/BackButton";

const ContactPage = () => {
  return (
    <>
      <Helmet>
        <title>Kontakt 061 Garage Poznań Wilda | Umów Detailing | 602 709 327</title>
        <meta 
          name="description" 
          content="Kontakt 061 Garage Poznań Wilda. Umów detailing: 602 709 327, 061garageds@gmail.com. Mobilny serwis detailingu w Poznaniu. Szybka rezerwacja!" 
        />
        <meta name="keywords" content="kontakt detailing Poznań Wilda, telefon 061 garage, umówić detailing Poznań, adres 061 garage, rezerwacja detailing, mobilny detailing Poznań" />
        <link rel="canonical" href="https://061garagedetailingstudio.pl/kontakt" />
        <meta property="og:title" content="Kontakt 061 Garage Poznań Wilda | Umów Detailing | 602 709 327" />
        <meta property="og:description" content="Umów detailing w Poznaniu Wilda! Tel: 602 709 327. Mobilny serwis detailingu. Szybka rezerwacja online." />
        <meta property="og:url" content="https://061garagedetailingstudio.pl/kontakt" />
        <meta property="og:image" content="https://061garagedetailingstudio.pl/lovable-uploads/5f17a190-693b-4d81-b673-957c3b473247.png" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="pl_PL" />
        <meta property="og:site_name" content="061 Garage Detailing Studio" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Kontakt 061 Garage Poznań Wilda | Umów Detailing | 602 709 327" />
        <meta name="twitter:description" content="Umów detailing w Poznaniu Wilda! Tel: 602 709 327. Mobilny serwis detailingu. Szybka rezerwacja online." />
        <meta name="twitter:image" content="https://061garagedetailingstudio.pl/lovable-uploads/5f17a190-693b-4d81-b673-957c3b473247.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": "Kontakt - 061 Garage Detailing Studio",
            "description": "Informacje kontaktowe i formularz kontaktowy",
            "provider": {
              "@type": "LocalBusiness",
              "name": "061 Garage Detailing Studio",
              "telephone": "+48602709327",
              "email": "061garageds@gmail.com"
            }
          })}
        </script>
      </Helmet>
      <BackButton />
      <AccessibilityEnhancer />
      <div className="min-h-screen bg-garage-dark text-white">
        <main id="main-content" role="main" aria-label="Kontakt - główna treść">
          <div className="pt-24 md:pt-28">
            <Contact />
          </div>
        </main>
        <Footer />
        <FloatingButtons />
      </div>
    </>
  );
};

export default ContactPage;
